import moment from 'moment';
import { AlpsRolesId, CensusAuditStatus } from '../types/enum';
import { CensusTypes } from '../types/censusTypes';
import { translate } from './locale';

/**
 * Converts a Alps Role Id to a display String
 * @param {AlpsRolesId} AlpsRole The Alps Role enum value
 * @returns Display Values
 */
export const ConvertyAlpsRoleToDisplay = (alpsRole: AlpsRolesId): string => {
	switch (alpsRole) {
		case AlpsRolesId.HeadTeacher:
			return translate(
				'manageAccount.additionalInformation.completeModal.stepOneText.jobRoles.HEAD'
			) as string;
		case AlpsRolesId.HeadOfSixth:
			return translate(
				'manageAccount.additionalInformation.completeModal.stepOneText.jobRoles.HEAD_OF_SIXTH'
			) as string;
		case AlpsRolesId.DataManager:
			return translate(
				'manageAccount.additionalInformation.completeModal.stepOneText.jobRoles.DATA_MANAGER'
			) as string;
		case AlpsRolesId.KS4Leader:
			return translate(
				'manageAccount.additionalInformation.completeModal.stepOneText.jobRoles.KS4_LEAD'
			) as string;
		case AlpsRolesId.Finance:
			return translate(
				'manageAccount.additionalInformation.completeModal.stepOneText.jobRoles.FINANCE'
			) as string;
		case AlpsRolesId.Champion:
			return translate(
				'manageAccount.additionalInformation.completeModal.stepOneText.jobRoles.CHAMPION'
			) as string;
		default:
			//Dunno what to defualt to so I guess an finance?
			return translate(
				'manageAccount.additionalInformation.completeModal.stepOneText.jobRoles.FINANCE'
			) as string;
	}
};

/**
 * Check Flag smith config of census periods
 * @param start start of census window
 * @param end end of census window
 * @param isFeatureOn is the feature flag on?
 * @returns true or false if we are within in census period AND the flag is on
 */
export const CalculateWithinCensus = (
	start: string,
	end: string,
	isFeatureOn: boolean
): boolean => {
	//local date time
	const localTime = moment.utc();
	//Compare local date time to census start and end
	const censusWindow = moment(localTime) > moment(start) && moment(localTime) < moment(end);
	return isFeatureOn && censusWindow;
};

export const hasPostponedDatePassed = (date: string): boolean => {
	//local date time
	const localTime = moment.utc();

	return moment(localTime) > moment(date);
};

/**
 *
 * @param desiredRoles The roles required for the Census
 * @param agreements All the active Sub info
 * @returns filtered down array of Alps roles
 */
//TODO: The strings will be changes to IDs in the following US 35439
export const filterCensusBasedOnSubAndContract = (
	desiredRoles: CensusTypes.alpsEnumType[],
	agreements: ManageAccount.SubscriptionAgreement[] | undefined,
	isMatChild: boolean
): CensusTypes.alpsEnumType[] => {
	// Ensure only active agreements
	const ensureActiveAgreements = agreements?.filter(
		(agreement) => agreement.subscriptionStatus === 'Active'
	);

	// Cover a failed fetch of the sub info
	if (agreements === undefined) {
		return desiredRoles;
	}

	// Make a copy of desiredRoles to filter
	let filteredRoles = [...desiredRoles];

	// If there is NO KS4 sub
	if (
		ensureActiveAgreements?.every(
			(agreement) =>
				agreement.subscriptionLevel !== 'KS4' && agreement.subscriptionLevel !== 'KS4KS5'
		)
	) {
		filteredRoles = filteredRoles.filter((role) => role !== AlpsRolesId.KS4Leader);
	}

	// If there is NO KS5 sub
	if (
		ensureActiveAgreements?.every(
			(agreement) =>
				agreement.subscriptionLevel !== 'KS5' && agreement.subscriptionLevel !== 'KS4KS5'
		)
	) {
		filteredRoles = filteredRoles.filter((role) => role !== AlpsRolesId.HeadOfSixth);
	}

	return filteredRoles;
};

/**
 * Check if the census status is allowed to show the modal
 * @param statusOfCensus The status of the census
 * @returns true or false if the census status is allowed to show the modal
 */
export const allowCensusStatusModalTracker = (statusOfCensus: CensusAuditStatus): boolean => {
	return (
		statusOfCensus !== CensusAuditStatus.Complete &&
		statusOfCensus !== CensusAuditStatus.UserHasPostponeButIsHasACurrentActiveSession &&
		statusOfCensus !== CensusAuditStatus.Pending &&
		statusOfCensus !== CensusAuditStatus.SuppressedForNewCustomer
	);
};
